import BaseController from '../..';
import IOrderHistory from './IOrderHistory';

export default class OrderHistory extends BaseController implements IOrderHistory {
    async fetchOrderHistory(orderId: string) {
        const response = await this.client.get(`/order/history/${orderId}`);
        return response;
    }
}
